import { palette } from '@/theme/constants';

export const styles = {
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: {
    border: `0.063rem solid ${palette.cardBorder}`,
    marginBottom: '0.5rem',
    width: '100%', // Fixed width to ensure consistent sizing
    margin: '0 auto', // Centers the divider horizontally
  },
};

